import type { Config } from 'src/models/config';
import type { Payment } from 'src/models/payment';

import { decryptJsonObject, encryptJsonObject } from '../encryption';

export const CONFIG_KEY = 'config';
export const PAYMENT_KEY = 'payment';
export const CHARGE_POINT_KEY = 'charge_point';
export const LANGUAGE_KEY = 'language';

export class LocalStorage {
  static getItem(key: string): Config | Payment | string | undefined {
    const item = localStorage.getItem(key);

    return item ? JSON.parse(item) : item;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static setItem(key: string, value: any) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  static getEncryptedItem(key: string): Payment | undefined {
    const item = localStorage.getItem(key);

    if (!item) return undefined;

    const decryptedItem = decryptJsonObject(item) as unknown as Payment;

    return decryptedItem;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static setEncryptedItem(key: string, value: any) {
    const encryptedItem = encryptJsonObject(value);

    localStorage.setItem(key, encryptedItem);
  }

  static removeItem(key: string) {
    localStorage.removeItem(key);
  }
}
